import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesResolutionsEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-resolutions-edit',
	path: '/secure/admin/EditResolution!default.jspa',
};
